var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            var StringHelper = /** @class */ (function () {
                function StringHelper() {
                }
                StringHelper.replaceAt = function (str, index, character) {
                    return str.substr(0, index) + character + str.substr(index + character.length);
                };
                // replaces {x} in string template with arguments 
                // supports multiple arguments
                // format("press {0} to {1}", "F1", "resume") -> "press F1 to resume"
                StringHelper.format = function (str) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return str.replace(/{(\d+)}/g, function (match, number) { return typeof args[number] != 'undefined'
                        ? args[number]
                        : match; });
                };
                ;
                StringHelper.validateEmail = function (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                };
                StringHelper.toDiffDateString = function (date, $filter) {
                    var $translate = $filter("translate");
                    var text;
                    var diff;
                    var currentDate = moment().seconds(0).milliseconds(0);
                    var days = currentDate.diff(moment(date), "days");
                    var hours = currentDate.diff(moment(date), "hours");
                    if (days > 365) {
                        diff = currentDate.diff(moment(date), "years", true);
                        text = $translate("YEARS_AGO").replace("{0}", parseFloat(diff.toFixed(1)).toString());
                    }
                    else if (days > 30) {
                        diff = currentDate.diff(moment(date), "months");
                        text = $translate("MONTHS_AGO").replace("{0}", diff.toString());
                    }
                    else if (days > 2) {
                        text = $translate("DAYS_AGO").replace("{0}", days.toString());
                    }
                    else if (hours > 2) {
                        text = $translate("HOURS_AGO").replace("{0}", hours.toString());
                    }
                    else {
                        diff = currentDate.diff(moment(date), "minutes");
                        if (diff < 0)
                            diff = 0;
                        text = $translate("MINUTES_AGO").replace("{0}", diff.toString());
                    }
                    return text;
                };
                StringHelper.secondsToHHMM = function (secNum) {
                    var hours = Math.floor(secNum / 3600);
                    var minutes = Math.floor((secNum - (hours * 3600)) / 60);
                    var text = "";
                    text += hours;
                    if (minutes < 10)
                        text += ":0" + minutes;
                    else {
                        text += ":" + minutes;
                    }
                    return text;
                };
                return StringHelper;
            }());
            Helpers.StringHelper = StringHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=StringHelper.js.map